import React from 'react';
import { GenericDetailPage } from '../../../components/generic';
import { useTicketStatus, TicketStatus } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => {
  return (
    <GenericDetailPage<TicketStatus>
      useData={useTicketStatus}
      config={{
        ...moduleConfig,
        getDetailSections,
        getStatusBadges,
      }}
    />
  );
};

export default Detail;
